module.exports = __webpack_public_path__ + "img/11.ac7461d1.jpg";